export default {
    path: 'index',
  
    component: () => import(/*webpackChunkName: 'sys-index'*/ '@views/index/views/index.vue'),
    meta: {
        title: '首页',
        topNav: true,
    },

}